import { NavLink, Outlet } from "react-router-dom";

const TransportMainPage = () => {
    return <Outlet />;
}

export default TransportMainPage;